export const buildSaitamaCsvIdentity = (row = {}) => {
  const gameSpaceId = row.game_space_id || row.gameSpaceId;
  const photographEventId = row.photograph_event_id || row.photographEventId;

  if (!gameSpaceId || !photographEventId) return null;

  return {
    game_space_id: gameSpaceId,
    photograph_event_id: photographEventId,
  };
};

export const sameSaitamaCsvIdentity = (left, right) => Boolean(
  left && right
  && left.game_space_id === right.game_space_id
  && left.photograph_event_id === right.photograph_event_id
);

export const toggleSaitamaCsvSelection = (selection = [], identity, selected) => {
  if (!identity) return selection;

  const withoutIdentity = selection.filter((item) => !sameSaitamaCsvIdentity(item, identity));
  return selected ? [...withoutIdentity, identity] : withoutIdentity;
};

export const toggleSaitamaCsvSelections = (selection = [], identities = [], selected) => {
  const validIdentities = identities.filter(Boolean);
  const selectedWithoutRows = selection.filter(
    (item) => !validIdentities.some((identity) => sameSaitamaCsvIdentity(item, identity))
  );

  return selected
    ? [...selectedWithoutRows, ...validIdentities]
    : selectedWithoutRows;
};
